// WithPageStatus.js
import { connect } from 'react-redux';
import getNetworkingData from '../selector/getNetworkingData.js';
import getListData from '../selector/getListData.js';
import WithPageStatus from '../component/WithPageStatus.jsx';

const mapStateToProps = (state, { path }) => {
  const nextPage = getListData(state, path, 'nextPage');

  return {
    isNextPageFetching: getNetworkingData(
      state,
      [...path, nextPage],
      'isFetching'
    ),
    isFirstPageFetching: getNetworkingData(
      state,
      [...path, 'firstPage'],
      'isFetching'
    ),
    isCurrentPageFetching: getNetworkingData(state, [...path], 'isFetching'),
    nextPage,
  };
};

export default connect(mapStateToProps)(WithPageStatus);
